export default {
  stepper: 1,
  drawer: null,
  color: 'gray'
}
